import React from "react"
import eyeCloseIcon from "../../../../images/eye-close.svg"
import { getRectColor } from "./utils/PostitUtils"
import AutoFitSvgText from "./layouts/AutoFitSvgText"

interface IProps {
  text: string
  card: ICard
}

const CardEmpty = ({ text, card }: IProps): React.JSX.Element => {
  return (
    <>
      <defs>
        <filter id="blur">
          <feGaussianBlur in="SourceGraphic" stdDeviation="4" />
        </filter>
      </defs>
      <g>
        <rect width="100" height="100" fill={getRectColor(card)} stroke="silver" strokeWidth="0.5" />
        <g filter="url(#blur)">
          <AutoFitSvgText text={text} />
        </g>
        <image
          href={eyeCloseIcon}
          x="32"
          y="32"
          width="36"
          height="29"
        />
      </g>
    </>
  )
}

export default CardEmpty
